import { render } from "./NewMainContainer.vue?vue&type=template&id=5f6fd21e&scoped=true"
import script from "./NewMainContainer.vue?vue&type=script&lang=js"
export * from "./NewMainContainer.vue?vue&type=script&lang=js"

import "./NewMainContainer.vue?vue&type=style&index=0&id=5f6fd21e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6fd21e"]])

export default __exports__